<template>
  <textarea v-if="!readOnly" :name="name"
            :id="name"
            @input="$emit('update:modelValue', $event.target.value); resize($event)"
            :value="modelValue"
            ref="guid"
            :readonly="readOnly"
            :placeholder="placeholder"
            :class="{'cursor-default': readOnly, 'cursor-text': !readOnly}">
  </textarea>
  <div v-else v-html="formattedText" class="cursor-default">
  </div>
</template>

<script>

  export default {
    props: {
      name: {
        type: String,
        required: true,
      },
      modelValue: {
        required: false,
      },
      placeholder: {
        type: String,
        required: false,
      },
      readOnly: {
        type: Boolean,
        required: false,
      },
    },
    data() {
      return {
        guid: this.$uuid(),
      };
    },
    mounted() {
      const element = this.$refs.guid;
      if (element) {
        element.style.height = 'auto';
        if (element.scrollHeight === 0) {
          element.style.height = '66px';
        } else {
          element.style.height = `${element.scrollHeight + 10}px`;
        }
      }
    },
    computed: {
      formattedText() {
        if (this.modelValue) return this.modelValue.replace(/\n/g, '<br>');
        return '';
      },
    },
    methods: {
      resize(e) {
        e.target.style.height = 'auto';
        e.target.style.height = `${e.target.scrollHeight + 10}px`;
      },
    },
  };
</script>
